<template>
  <div>
    <van-nav-bar title="服务资讯类" fixed class="jump-nav-bar" left-arrow @click-left="back" />
    <div class="cont">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        :offset="100"
      >
        <van-row
          class="item"
          v-for="(item,index) of list"
          :key="index"
          @click.native="goChat(item)"
        >
          <van-col span="4" class="left">
            <div class="avator">
              <img src="../../assets/avatar.png" class="avaImg" />
              <span class="jump-usercent-orderste-dot2" v-if="!item.content"></span>
            </div>
          </van-col>
          <van-col class="right" span="19">
            <p class="header">
              <span class="title">{{item.userName}}</span>
              <span class="time">{{item.createtime}}</span>
            </p>
            <p class="content">{{item.replyConten}}</p>
          </van-col>
        </van-row>
      </van-list>
    </div>
  </div>
</template>

<script>
import {
  NavBar,
  Row,
  Col,
  Tab,
  Tabs,
  Button,
  List,
  Field,
  Tabbar,
  TabbarItem
} from "vant";
export default {
  components: {
    [NavBar.name]: NavBar,
    [Row.name]: Row,
    [Col.name]: Col,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Button.name]: Button,
    [Field.name]: Field,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [List.name]: List
  },
  data() {
    return {
      list: [],
      tabActive: 2,
      loading: false,
      finished: false,
      total:0,
      pageNum:1
    };
  },
  mounted() {
    document.getElementsByClassName("cont")[0].style.minHeight =
      window.innerHeight - 60 + "px";
  },
  methods: {
    onLoad() {

  
      this.$api.get(
        this.jumuc.userCenter.selConsult,
        {
          currentPage: this.pageNum,
          pageSize: 10,
          userId: localStorage.getItem("userId")
        },
        successRes => {
          if (successRes.success) {
            let list = successRes.data.list.list;
            for (let i = 0; i < list.length; i++) {
              this.list.push(list[i]);
            }
            this.pageNum = successRes.data.list.pages + 1;
            this.total = successRes.data.list.total;
            // 加载状态结束
            this.loading = false;
            // 数据全部加载完成
            if (this.list.length >= this.total) {
              this.finished = true;
            }
          }
        }
      );
    },
    goChat(item) {
      var cont = "";
      if (item.content) {
        cont = item.content;
      }
      this.$router.push({
        path: "/chat",
        query: {
          typeName: item.userName,
          id: item.consultId,
          cont: cont,
          wen: item.replyConten,
          lookId: item.id
        }
      });
    },
    back() {
      history.go(-1);
    }
  }
};
</script>

<style lang="less" scoped>
#app {
  background-color: #fff !important;
}
.jump-usercent-orderste-dot2 {
  background: red;
  display: block;
  width: 10px;
  height: 10px;
  border-radius: 100%;
  position: absolute;
  top: -1px;
  left: 39px;
}
.cont {
  padding: 0 10px 50px;
  background: #fff;
}
.item {
  padding: 10px 0;
  border-bottom: 1px solid #eee;
  .avator {
    width: 46px;
    height: 46px;
    border-radius: 15px;
    position: relative;
    text-align: center;
    img {
      width: 26px;
      height: 26px;
      margin-top: 10px;
    }
    .avaImg {
      width: 46px;
      height: 46px;
      margin-top: 0;
    }
  }
  .right {
    .header {
      display: flex;
      justify-content: space-between;
      .title {
        font-size: 16px;
        color: #000;
      }
      .time {
        color: #7d7e80;
        font-size: 12px;
      }
    }
    .content {
      white-space: nowrap;
      color: #969799;
      font-size: 15px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>